/**
 * AIOL Mobile Category Pills v2
 * Reads from [data-aiol-filter] nav in sidebar (even if sidebar is hidden)
 * Creates horizontal scrollable pills above the product grid on mobile.
 */
(function() {
  function initMobilePills() {
    if (window.innerWidth > 768) return;
    if (document.querySelector('.aiol-mobile-cats')) return;

    // Find the filter nav (may be hidden inside sidebar)
    var filterNav = document.querySelector('[data-aiol-filter]');
    if (!filterNav) return;

    var colUrl = filterNav.getAttribute('data-collection-url') || '';
    var activeTag = filterNav.getAttribute('data-active-tag') || '';

    // Build pill container
    var pillRow = document.createElement('div');
    pillRow.className = 'aiol-mobile-cats';
    pillRow.setAttribute('aria-label', 'Filter by category');
    pillRow.setAttribute('role', 'navigation');

    // Read links with data attributes
    var links = filterNav.querySelectorAll('a[data-tag-label]');
    if (!links.length) return;

    links.forEach(function(link) {
      var label = link.getAttribute('data-tag-label') || link.textContent.trim();
      var href = link.href;
      var isCurrent = link.getAttribute('aria-current') === 'page';
      var isActive = isCurrent || link.parentElement.classList.contains('active');

      var pill = document.createElement('a');
      pill.href = href;
      pill.className = 'aiol-cat-pill' + (isActive ? ' active' : '');
      pill.textContent = label;
      if (isActive) pill.setAttribute('aria-current', 'page');

      pillRow.appendChild(pill);
    });

    if (pillRow.children.length === 0) return;

    // Insert above the product grid
    var insertBefore = (
      document.querySelector('.productgrid--outer') ||
      document.querySelector('.productgrid--wrapper') ||
      document.querySelector('[data-productgrid]') ||
      document.querySelector('.productgrid')
    );

    if (insertBefore && insertBefore.parentNode) {
      insertBefore.parentNode.insertBefore(pillRow, insertBefore);
    } else {
      // Fallback: after H1
      var h1 = document.querySelector('h1');
      if (h1 && h1.parentNode) {
        h1.parentNode.insertBefore(pillRow, h1.nextElementSibling);
      }
    }
  }

  // Wait for sidebar to be rendered then build pills
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initMobilePills, 800);
    });
  } else {
    setTimeout(initMobilePills, 800);
  }
})();
